"use client";

import clsx from "clsx";
import {
  isSidebarNavigationItemActive,
  type SidebarNavigationLinkOrGroup,
  type SidebarNavigationSectionLabel,
} from "./navigation";

export default function SideNavigationSection({
  label,
}: {
  label: SidebarNavigationSectionLabel;
}) {
  return (
    <div className="w-full rounded-md flex flex-col gap-1">
      <div className="flex items-center">
        <div className="w-0.5 h-4 mr-1.5 shrink-0 bg-transparent" />
        <div
          className={clsx(
            "text-[11px] tracking-wider uppercase font-semibold py-1 rounded px-1 -mx-1 transition-colors text-grey",
          )}
        >
          {label.title}
        </div>
      </div>
    </div>
  );
}
